import { render, staticRenderFns } from "./house-info.vue?vue&type=template&id=572440c5&scoped=true&"
import script from "./house-info.vue?vue&type=script&lang=js&"
export * from "./house-info.vue?vue&type=script&lang=js&"
import style0 from "./house-info.vue?vue&type=style&index=0&id=572440c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572440c5",
  null
  
)

export default component.exports